import React from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './InvoiceEmailButtons.css';
import Btn from '../../../component/button/btn/Btn';
import {YELLOW_ORANGE} from '../../../globalVariables/GlobalVariables';

const style = `
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border:none;
`;

function InvoiceEmailButtons() {
    const {t} = useTranslation('branding');

    return (
        <css.wrapper data-cy="invoiceEmailButtons">
            <Btn style={style} onClick={undefined}>{t('personalArea')}</Btn>
            <Btn style={style + ` background-color:${YELLOW_ORANGE};`} onClick={undefined}>
                {t('downloadReceiptButton')}
            </Btn>
        </css.wrapper>
    );
}

export default InvoiceEmailButtons;

